module.exports = __webpack_public_path__ + "img/work.be5030ca.webp";